// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/aoa-indicators.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/aoa-indicators/aoa-indicators.js';

mount([g0]);
